import { ActionType } from '../../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../../core/api/rsaa';
import { Endpoints } from '../../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../../core/api/module';
import * as R from 'ramda';
import { CollaboratorAuthInfo } from '../currentCollaboratorState';


const KEY_ACTION = ActionType.AuthenticateCollaboratorRequest;
const ACTIONS    = [
  ActionType.AuthenticateCollaboratorRequest,
  ActionType.AuthenticateCollaboratorResponse,
  ActionType.AuthenticateCollaboratorError,
];

type Payload = CollaboratorAuthInfo;
type Meta = {
  displayProjectId: string;
  participantId: number;
  email: string;
};


/**
 * Dispatch this action to authenticate a user accessing the portal from a collaborator invite email
 */
export const authenticateCollaboratorAction = (
  displayProjectId: string,
  participantId: number,
  email: string,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.AuthenticateCollaborator,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({
    displayProjectId: displayProjectId,
    participantId:    participantId,
    email:            email,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { displayProjectId: displayProjectId, participantId, email }),
  bailout:  state => !!getLoading(state, KEY_ACTION, `${displayProjectId}-${participantId}-${email}`),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const { displayProjectId, participantId, email } = action.meta;

  const requestId = `${displayProjectId}-${participantId}-${email}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, requestId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, requestId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, requestId);

  if (!payload) {
    return successState;
  }

  return R.assocPath(
    ['devPlan', 'currentCollaborator'],
    R.assocPath(['currentProject', 'displayProjectId'], displayProjectId, payload),
    successState,
  );
};


export const authenticateCollaboratorReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
